var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c("script",{tag:"Component",attrs:{"type":"application/ld+json"}},[_vm._v("\n    "+_vm._s(_setup.jsonLD)+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }